import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const UserImageDefaultProps = {
  ...ClassNameDefaultProps,
  avatar: null, // TODO: avatar proptypes ?
  color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
  firstName: null,
  identifier: null,
  lastName: null,
};

export const UserImagePropTypes = {
  ...ClassNamePropTypes,
  avatar: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]), // TODO: avatar proptypes ?
  color: PropTypes.string,
  firstName: PropTypes.string,
  identifier: PropTypes.string,
  lastName: PropTypes.string,
};
